export default __webpack_public_path__ + "static/media/558.66bb9e1e.jpg";